import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";  // ✅ Added Helmet provider

// ====== Pages ======
import Home from "./Ashtavinayak_hospital_Home";
import About from "./Ashtavinayak_hospital_About";
import Facilities from "./Ashtavinayak_hospital_Facilities";
import Contact from "./Ashtavinayak_hospital_Contact";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/facilities" element={<Facilities />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
